import React from 'react';
import { SvgIcon } from '../styled-components';
import { SvgIconProps } from '@material-ui/core/SvgIcon';

const SaunaIcon: React.FC<SvgIconProps> = ({
  viewBox = '0 0 36.459 43.533',
  ...rest
}) => (
  <SvgIcon
    {...rest}
    viewBox={viewBox}
    style={{ width: 36.459, height: 43.533 }}
  >
    <g
      xmlns="http://www.w3.org/2000/svg"
      transform="translate(-543.092 -71.378)"
    >
      <path
        fill="none"
        stroke="#224060"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2px"
        d="M567.276,113.911h-14.37a4.782,4.782,0,0,1-4.729-4.069L545.317,90.9h29.549l-2.86,18.944A4.783,4.783,0,0,1,567.276,113.911Z"
      />
      <line
        fill="none"
        stroke="#224060"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2px"
        x2="26.838"
        transform="translate(546.672 98.492)"
      />
      <line
        fill="none"
        stroke="#224060"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2px"
        x2="26.838"
        transform="translate(546.672 95.425)"
      />
      <line
        fill="none"
        stroke="#224060"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2px"
        x2="23.74"
        transform="translate(548.044 106.255)"
      />
      <line
        fill="none"
        stroke="#224060"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2px"
        x2="22.74"
        transform="translate(549.044 109.47)"
      />
      <path
        fill="none"
        stroke="#224060"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2px"
        d="M552.7,90.9h-7.386l-1.174-6.48a3.65,3.65,0,0,1,3.606-4.211h0a3.65,3.65,0,0,1,3.606,3.088Z"
      />
      <line
        fill="none"
        stroke="#224060"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2px"
        y1="18.265"
        x2="5.809"
        transform="translate(572.486 72.634)"
      />
    </g>
  </SvgIcon>
);

export default SaunaIcon;
